// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"537f910e","416":"92ee00ac","544":"d136e2d9","568":"375fcfb5"}[chunkId] + ".chunk.js";
};